<template>
  <footer class="footer-area">
    <div class="container">
      <div class="row">
        <div class="copyright-text">
          © 2021 All rights reserved. Design & Code with
          <span class="material-icons">
            favorite
          </span>
          by
          <a
            href="https://github.com/jedchang"
            target="_blank"
          >Jed Chang</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/components/_footer.scss';
</style>
